import { SandboxShell } from "@/components/app/sandbox-shell";
import { HydrationBoundary } from "@tanstack/react-query";
import { Route } from "/app/src/routes/{-$locale}/sandboxes/$id.tsx";
const SplitComponent = () => {
  const {
    dehydratedState
  } = Route.useLoaderData() as {
    dehydratedState: DehydratedState;
    id: string;
  };
  return <HydrationBoundary state={dehydratedState}>
        <SandboxShell id={Route.useParams().id} />
      </HydrationBoundary>;
};
export { SplitComponent as component };